module.exports = __webpack_public_path__ + "static/paris-020-226c59a2610fa29e44cf57bb86b6644f.jpg";